import React from 'react';
import './SectionHeading.css';

/**
 * SectionHeading - Consistent heading component for page sections
 * @param {string} eyebrow - Small text above main heading (optional)
 * @param {string} children - Main heading text (h2 by default)
 * @param {string} [subheading] - Text below main heading (optional)
 * @param {'h1' | 'h2' | 'h3'} [level] - Heading level (defaults to h2)
 * @param {string} [align] - Text alignment: 'left', 'center', 'right' (defaults to 'left')
 * @param {string} [className] - Additional CSS classes
 */
const SectionHeading = ({
  eyebrow,
  children,
  subheading,
  level = 'h2',
  align = 'left',
  className = ''
}) => {
  const HeadingTag = level;

  return (
    <div className={`section-heading section-heading--${align} ${className}`}>
      {eyebrow && (
        <p className="section-heading__eyebrow">{eyebrow}</p>
      )}
      <HeadingTag className="section-heading__title">{children}</HeadingTag>
      {subheading && (
        <p className="section-heading__subheading">{subheading}</p>
      )}
    </div>
  );
};

export default SectionHeading;
